module.exports = __webpack_public_path__ + "static/media/phi-jumbo.ad3e71b4.jpg";